import React from 'react';
import './ProductPage.css'; // Use the same CSS file for shared styles and skeleton effects

const ProductSkeleton = () => {
    return (
        <div className="product-page">
            <div className="product-container skeleton-container">

                {/* 1. Image and Thumbnails Section Skeleton */}
                <div className="product-images skeleton-images">
                    {/* Main Image */}
                    <div className="main-image skeleton-main-image">
                        <div className="skeleton-line full-height"></div>
                    </div>
                    {/* Thumbnails */}
                    <div className="thumbnail-images skeleton-thumbnails">
                        <div className="thumbnail skeleton-box"></div>
                        <div className="thumbnail skeleton-box"></div>
                        <div className="thumbnail skeleton-box"></div>
                    </div>
                </div>

                {/* 2. Product Details Section Skeleton */}
                <div className="product-details skeleton-details">

                    {/* Title and Rating */}
                    <div className="product-header">
                        <div className="skeleton-line medium-width"></div>
                    </div>

                    {/* Color and Pricing */}
                    <div className="skeleton-line short-width"></div>
                    <div className="product-pricing" style={{marginTop: '10px'}}>
                        <div className="skeleton-line extra-short-width"></div>
                    </div>

                    {/* Size Selection */}
                    <div className="size-selection" style={{marginTop: '30px'}}>
                        <div className="size-header">
                            <div className="skeleton-line short-width"></div>
                        </div>
                        <div className="size-options">
                            <div className="size-btn skeleton-box"></div>
                            <div className="size-btn skeleton-box"></div>
                            <div className="size-btn skeleton-box"></div>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="action-buttons" style={{marginTop: '40px'}}>
                        <div className="add-to-cart-btn skeleton-box"></div>
                        <div className="shop-pay-btn skeleton-box"></div>
                    </div>

                    {/* Shipping/Returns */}
                    <div className="shipping-returns" style={{marginTop: '40px'}}>
                         <div className="skeleton-line medium-width"></div>
                         <div className="skeleton-line medium-width"></div>
                    </div>

                    {/* Accordion Sections */}
                    <div className="accordion-sections" style={{marginTop: '30px'}}>
                        <div className="skeleton-accordion-header">
                            <div className="skeleton-line long-width"></div>
                        </div>
                        <div className="skeleton-accordion-header">
                            <div className="skeleton-line long-width"></div>
                        </div>
                        <div className="skeleton-accordion-header">
                            <div className="skeleton-line long-width"></div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ProductSkeleton;